import { DestroyRef, Directive, ElementRef, inject, NgZone } from "@angular/core";
import { AgGridAngular } from "ag-grid-angular";

import { GlossScrollbar, glossScrollEnhanced } from "./gloss-scrollbar";

/**
 * GlossScroll's overlay bar on an ag-grid. The grid's columns scroll sideways in its own
 * `.ag-center-cols-viewport` (whose native bar ag-grid already hides), with a separate fake
 * horizontal bar under the rows; once the grid is ready this puts the overlay bar on that viewport
 * and hides the fake one (`.gs-ag-grid`, base.scss). The grids here use domLayout autoHeight, so
 * they never scroll vertically inside. Touch-only devices keep ag-grid's own bar.
 */
@Directive({
  selector: "ag-grid-angular[appGlossScrollGrid]",
  standalone: true,
})
export class GlossScrollGridDirective {
  private readonly host = inject<ElementRef<HTMLElement>>(ElementRef);
  private readonly zone = inject(NgZone);
  private scrollbar?: GlossScrollbar;

  constructor() {
    const subscription = inject(AgGridAngular).gridReady.subscribe(() => this.attach());
    inject(DestroyRef).onDestroy(() => {
      subscription.unsubscribe();
      this.scrollbar?.destroy();
    });
  }

  private attach(): void {
    const viewport = this.host.nativeElement.querySelector<HTMLElement>(".ag-center-cols-viewport");
    if (!viewport || this.scrollbar || !glossScrollEnhanced()) {
      return;
    }
    this.host.nativeElement.classList.add("gs-ag-grid");
    this.zone.runOutsideAngular(() => {
      this.scrollbar = new GlossScrollbar(viewport, { enhanced: true });
    });
  }
}
